export default __webpack_public_path__ + "static/media/google-play-el.2f3c6aac.svg";